var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import { Color } from '../const/';
var TabsStateless = (function (_super) {
    __extends(TabsStateless, _super);
    function TabsStateless() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabsStateless.prototype.onClickTab = function (t) {
        var onClickTab = this.props.onClickTab;
        if (typeof onClickTab === 'function') {
            onClickTab(t);
        }
    };
    TabsStateless.prototype.render = function () {
        var _this = this;
        var _a = this.props, selectedTab = _a.selectedTab, textArray = _a.textArray, className = _a.className;
        return (React.createElement(Row, { className: className }, textArray.map(function (t, i) { return (React.createElement(TabItem, { onClick: function () { return _this.onClickTab(t); }, isSelected: t === selectedTab, key: i }, t)); })));
    };
    TabsStateless.defaultProps = {
        onClick: function () { },
    };
    return TabsStateless;
}(React.Component));
var Row = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  border-bottom: 1px solid ", ";\n"], ["\n  width: 100%;\n  border-bottom: 1px solid ", ";\n"])), Color.BORDER_COLOR);
var TabItem = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  padding: 8px 24px;\n  font-size: 16px;\n  cursor: pointer;\n  color: ", ";\n  border-bottom: ", ";\n"], ["\n  display: inline-block;\n  padding: 8px 24px;\n  font-size: 16px;\n  cursor: pointer;\n  color: ", ";\n  border-bottom: ",
    ";\n"])), function (props) { return (props.isSelected ? "" + Color.BRAND_PRIMARY : 'black'); }, function (props) {
    return props.isSelected ? "solid 2px " + Color.BRAND_PRIMARY : 'white';
});
export default TabsStateless;
var templateObject_1, templateObject_2;
//# sourceMappingURL=tabs-stateless.js.map